import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { DIALOGUE_SUPPORT_EMAIL } from '@/constants';

const ConnectUsStyles = styled(UiTypography)`
  margin: 24px auto 0;
  padding: 12px;
  border-top: 1px solid #e0e2e8;

  a {
    color: inherit;
  }
`;

export const ConnectUs: React.FC = () => {
  return (
    <ConnectUsStyles
      variant="body-medium"
      className="questions-email"
      align="center"
    >
      If you have any questions - reach us at{' '}
      <a href={`mailto:${DIALOGUE_SUPPORT_EMAIL}`} target="_blank">
        {DIALOGUE_SUPPORT_EMAIL}
      </a>
    </ConnectUsStyles>
  );
};
